import { Row } from 'antd';
import { AButton, AModal, ARate } from '../../../../components';
import { IChartPointLogProps } from '../../../../shared/interfaces';
import { TextLabel, TextValue } from './styles';
import { formatDate } from '../../../../shared/utils/format-date';

interface IDetailsLogProps {
  open: boolean;
  close: () => void;
  log: IChartPointLogProps | null;
}

const DetailsLog: React.FC<IDetailsLogProps> = ({ open, close, log }) => {
  return (
    <AModal
      open={open}
      close={close}
      title={'Detalhes da Evolução'}
      footer={
        <AButton key="close" type="default" onClick={close}>
          Fechar
        </AButton>
      }
    >
      <Row>
        <TextLabel>Data:</TextLabel>
        <TextValue>{formatDate(log?.date)}</TextValue>
      </Row>
      <Row>
        <TextLabel>Hora:</TextLabel>
        <TextValue>{log?.time}</TextValue>
      </Row>
      <Row>
        <TextLabel>Descrição:</TextLabel>
        <TextValue>{log?.observation}</TextValue>
      </Row>
      <Row>
        <TextLabel>Rank:</TextLabel>
        <ARate
          value={log?.rank}
          tooltips={['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']}
          count={10}
          disabled
        />
      </Row>
    </AModal>
  );
};
export default DetailsLog;
